<template>
    <span>
        <font-awesome-layers fixed-width>
            <font-awesome-icon
                icon="user-friends"
                fixed-width />
            <font-awesome-icon
                class="text-white"
                icon="circle"
                transform="shrink-6 down-6 right-9" />
            <font-awesome-icon
                class="secondary-icon"
                icon="info-circle"
                transform="shrink-5 down-6 right-9" />
        </font-awesome-layers>
        <span>
            {{ changeWordingRegistrationBuy ? $t('menu.personDetails') : $t('menu.participantsDetails') }}
        </span>
    </span>
</template>
<script>
import registrationOnlineRegistrationFieldsMixin
    from "@/mixins/registration/registrationOnlineRegistrationFieldsMixin";

export default {
    name: 'MenuItemParticipantsDetails',
    mixins: [registrationOnlineRegistrationFieldsMixin],
}
</script>
<style lang="scss" scoped>

</style>